<template>
  <div class="list" flex="dir:top" :style="{height:wapperHeight}">
    <div class="list__title" flex="cross:center box:mean">
      <el-row :gutter="20">
        <el-col :span="4" flex="main:center">
          <div>用户名</div>
        </el-col>
        <el-col :span="4" flex="main:center">
          <div>测试11</div>
        </el-col>
        <el-col :span="4" flex="main:center">
          <div>测试111</div>
        </el-col>
        <el-col :span="4" flex="main:center">
          <div>测试1111</div>
        </el-col>
        <el-col :span="4" flex="main:center">
          <div>测试111</div>
        </el-col>
        <el-col :span="4" flex="main:center">
          <div>测试1111</div>
        </el-col>
      </el-row>
    </div>

    <div class="list__content" flex="cross:center box:mean">
      <el-row :gutter="20">
        <el-col :span="4" flex="main:center">
          <div>张三</div>
        </el-col>
        <el-col :span="4" flex="main:center">
          <div>测试11</div>
        </el-col>
        <el-col :span="4" flex="main:center">
          <div>测试111</div>
        </el-col>
        <el-col :span="4" flex="main:center">
          <div>测试1111</div>
        </el-col>
        <el-col :span="4" flex="main:center">
          <div>测试111</div>
        </el-col>
        <el-col :span="4" flex="main:center">
          <div>测试1111</div>
        </el-col>
      </el-row>
    </div>

    <div class="list__content" flex="cross:center box:mean">
      <el-row :gutter="20">
        <el-col :span="4" flex="main:center">
          <div>张三</div>
        </el-col>
        <el-col :span="4" flex="main:center">
          <div>测试11</div>
        </el-col>
        <el-col :span="4" flex="main:center">
          <div>测试111</div>
        </el-col>
        <el-col :span="4" flex="main:center">
          <div>测试1111</div>
        </el-col>
        <el-col :span="4" flex="main:center">
          <div>测试111</div>
        </el-col>
        <el-col :span="4" flex="main:center">
          <div>测试1111</div>
        </el-col>
      </el-row>
    </div>

    <div class="list__content" flex="cross:center box:mean">
      <el-row :gutter="20">
        <el-col :span="4" flex="main:center">
          <div>张三</div>
        </el-col>
        <el-col :span="4" flex="main:center">
          <div>测试11</div>
        </el-col>
        <el-col :span="4" flex="main:center">
          <div>测试111</div>
        </el-col>
        <el-col :span="4" flex="main:center">
          <div>测试1111</div>
        </el-col>
        <el-col :span="4" flex="main:center">
          <div>测试111</div>
        </el-col>
        <el-col :span="4" flex="main:center">
          <div>测试1111</div>
        </el-col>
      </el-row>
    </div>

    <div class="list__content" flex="cross:center box:mean">
      <el-row :gutter="20">
        <el-col :span="4" flex="main:center">
          <div>张三</div>
        </el-col>
        <el-col :span="4" flex="main:center">
          <div>测试11</div>
        </el-col>
        <el-col :span="4" flex="main:center">
          <div>测试111</div>
        </el-col>
        <el-col :span="4" flex="main:center">
          <div>测试1111</div>
        </el-col>
        <el-col :span="4" flex="main:center">
          <div>测试111</div>
        </el-col>
        <el-col :span="4" flex="main:center">
          <div>测试1111</div>
        </el-col>
      </el-row>
    </div>

    <div class="list__content" flex="cross:center box:mean">
      <el-row :gutter="20">
        <el-col :span="4" flex="main:center">
          <div>张三</div>
        </el-col>
        <el-col :span="4" flex="main:center">
          <div>测试11</div>
        </el-col>
        <el-col :span="4" flex="main:center">
          <div>测试111</div>
        </el-col>
        <el-col :span="4" flex="main:center">
          <div>测试1111</div>
        </el-col>
        <el-col :span="4" flex="main:center">
          <div>测试111</div>
        </el-col>
        <el-col :span="4" flex="main:center">
          <div>测试1111</div>
        </el-col>
      </el-row>
    </div>

    <div class="list__content" flex="cross:center box:mean">
      <el-row :gutter="20">
        <el-col :span="4" flex="main:center">
          <div>张三</div>
        </el-col>
        <el-col :span="4" flex="main:center">
          <div>测试11</div>
        </el-col>
        <el-col :span="4" flex="main:center">
          <div>测试111</div>
        </el-col>
        <el-col :span="4" flex="main:center">
          <div>测试1111</div>
        </el-col>
        <el-col :span="4" flex="main:center">
          <div>测试111</div>
        </el-col>
        <el-col :span="4" flex="main:center">
          <div>测试1111</div>
        </el-col>
      </el-row>
    </div>

    <div class="list__content" flex="cross:center box:mean">
      <el-row :gutter="20">
        <el-col :span="4" flex="main:center">
          <div>张三</div>
        </el-col>
        <el-col :span="4" flex="main:center">
          <div>测试11</div>
        </el-col>
        <el-col :span="4" flex="main:center">
          <div>测试111</div>
        </el-col>
        <el-col :span="4" flex="main:center">
          <div>测试1111</div>
        </el-col>
        <el-col :span="4" flex="main:center">
          <div>测试111</div>
        </el-col>
        <el-col :span="4" flex="main:center">
          <div>测试1111</div>
        </el-col>
      </el-row>
    </div>

    <div class="list__content" flex="cross:center box:mean">
      <el-row :gutter="20">
        <el-col :span="4" flex="main:center">
          <div>张三</div>
        </el-col>
        <el-col :span="4" flex="main:center">
          <div>测试11</div>
        </el-col>
        <el-col :span="4" flex="main:center">
          <div>测试111</div>
        </el-col>
        <el-col :span="4" flex="main:center">
          <div>测试1111</div>
        </el-col>
        <el-col :span="4" flex="main:center">
          <div>测试111</div>
        </el-col>
        <el-col :span="4" flex="main:center">
          <div>测试1111</div>
        </el-col>
      </el-row>
    </div>

    <div class="list__content" flex="cross:center box:mean">
      <el-row :gutter="20">
        <el-col :span="4" flex="main:center">
          <div>张三</div>
        </el-col>
        <el-col :span="4" flex="main:center">
          <div>测试11</div>
        </el-col>
        <el-col :span="4" flex="main:center">
          <div>测试111</div>
        </el-col>
        <el-col :span="4" flex="main:center">
          <div>测试1111</div>
        </el-col>
        <el-col :span="4" flex="main:center">
          <div>测试111</div>
        </el-col>
        <el-col :span="4" flex="main:center">
          <div>测试1111</div>
        </el-col>
      </el-row>
    </div>

    <div class="list__content" flex="cross:center box:mean">
      <el-row :gutter="20">
        <el-col :span="4" flex="main:center">
          <div>张三</div>
        </el-col>
        <el-col :span="4" flex="main:center">
          <div>测试11</div>
        </el-col>
        <el-col :span="4" flex="main:center">
          <div>测试111</div>
        </el-col>
        <el-col :span="4" flex="main:center">
          <div>测试1111</div>
        </el-col>
        <el-col :span="4" flex="main:center">
          <div>测试111</div>
        </el-col>
        <el-col :span="4" flex="main:center">
          <div>测试1111</div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  props: {
    height: {
      type: String,
      default: "110px"
    }
  },
  data() {
    let clientHeight = document.body.clientHeight;
    function getValue(per) {
      return (per * clientHeight) / 100;
    }
    return {
      wapperHeight: getValue(35) + "px"
    };
  },
  created() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
.list {
  background-color: rgba(64, 162, 118, 0);
  border-image-source: url("../../image/border.png");
  border-image-slice: 10;
  border-image-width: 3;
  border-style: solid;
  box-sizing: border-box;
  width: 100%;
  height: 109px;
  touch-action: none;
  color: #fff;
  font-weight: bold;
  padding-top: 10px;
  &__title {
    font-size: 14px;
    height: 30px;
    border-top: 1px solid rgb(60, 129, 171);
    border-bottom: 1px solid rgb(141, 198, 233);
  }
  &__content {
    height: 30px;
    font-size: 12px;
    color: rgb(197, 221, 238);
    border-bottom: 1px solid rgb(36, 97, 134);
  }
}
</style>
